import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromActions from './actions';

export interface State {
    version: string;
}

export const initialState: State = {
    version: '0.0.0'
};
export function reducer(
    state: State | undefined = initialState,
    action: fromActions.ActionsUnion
): State {
    switch (action.type) {
        case fromActions.ActionTypes.VersionSuccess:
            return {
                ...state,
                version: action.payload.version
            };
        default:
            return state;
    }
}

export const selectReminderState = createFeatureSelector<State>('version');

export const selectVersion = createSelector(
    selectReminderState,
    (state: State) => state.version
);
